import { http,download } from "@/api/public"
export const appApi = {

  getRouters(params) {
    return http('/system/api-web/ut/user/getRouters', params)
  },
  getUserInfo(params) {
    return http('/system/api-web/ut/user/getUserInfo', params)
  },
  getTestIntro(params) {
    return http('/mind/api-web/ut/mindTest/getTestIntro', params)
  },

  getTestUserInfo(params) {
    return http('/mind/api-web/ut/mindTest/getTestUserInfo', params)
  },
  getTestQuestionList(params) {
    return http('/mind/api-web/ut/mindTest/getTestQuestionList', params)
  },
  saveMindTest(params) {
    return http('/mind/api-web/ut/mindTest/saveMindTest', params)
  },
  getResultHolisticApproach(params) {
    return http('/mind/api-web/ut/mindTest/getResultHolisticApproach', params)
  },
  getResultFlagWarning(params) {
    return http('/mind/api-web/ut/mindTest/getResultFlagWarning', params)
  },
  getResultTypePersonality(params) {
    return http('/mind/api-web/ut/mindTest/getResultTypePersonality', params)
  },
  getResultTrendAnalysis(params) {
    return http('/mind/api-web/ut/mindTest/getResultTrendAnalysis', params)
  },
  getResultSubitemAnalysisMindTest(params) {
    return http('/mind/api-web/ut/mindTest/getResultSubitemAnalysis', params)
  },

  getSchoolGradeClassList(params) {
    return http('/mind/api-web/ut/mindTest/getSchoolGradeClassList', params)
  },

  getStudentList(params) {
    return http('/mind/api-web/ut/mindTest/getStudentList', params)
  },
  getResultFlagWarning(params) {
    return http('/mind/api-web/ut/mindTest/getResultFlagWarning', params)
  },
  getTestDate(params) {
    return http('/mind/api-web/ut/studentProfile/getTestDate', params)
  },
  // 登出
  logout(params) {
    return http('/auth/api-web/ut/authentication/logout', params)
  },
  getResultTitleList(params) {
    return http('/mind/api-web/ut/patrioticTest/getResultTitleList', params)
  },
  getPatrioticTestList(params) {
    return http('/mind/api-web/ut/patrioticTest/getTestQuestionList', params)
  },
  savePatrioticTest(params) {
    return http('/mind/api-web/ut/patrioticTest/savePatrioticTest', params)
  },
  getResultSubitemAnalysis(params) {
    return http('/mind/api-web/ut/patrioticTest/getResultSubitemAnalysis', params)
  },
  getTestBullyQuestionList(params) {
    return http('/mind/api-web/ut/bullyTest/getTestQuestionList', params)
  },
  saveBullyTest(params) {
    return http('/mind/api-web/ut/bullyTest/saveBullyTest', params)
  },
  getResultSubitemList(params) {
    return http('/mind/api-web/ut/mindTest/getResultSubitemList', params)
  },

  getUserinfo(params) {
    return http('/mind/api-web/ut/userinfo/getUserinfo', params)
  },
  updateInfo(params) {
    return http('/mind/api-web/ut/userinfo/updateInfo', params)
  },
  getGradeClassList(params) {
    return http('/system/api-web/nt/info/getGradeClassList', params)
  },
  downloadPDFReportHigh(params) {
    return download('/mind/api-web/ut/mindTest/downloadPDFReport', params, "心理测评报告.pdf")
  },
  getResultSubitemAnalysisQuestion(params) {
		return http('/mind/api-web/ut/mindTest/getResultSubitemAnalysisQuestion', params)
	},
	getResultEvaluationAnalysis(params) {
		return http('/mind/api-web/ut/mindTest/getResultEvaluationAnalysis', params)
	},
}
